"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListSkeleton = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _productListClasses = _interopRequireDefault(require("../../containers/ProductListContainer/productListClasses"));
var _styles = require("../List/styles");
var _styles2 = require("../Pagination/styles");
var _styles3 = require("../ProductList/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ListSkeleton = ({
  animation = 'pulse',
  className,
  renderItemSkeleton,
  renderListSkeleton,
  shouldRenderItemCount,
  shouldRenderPagination,
  numberOfItems = _constants.DEFAULT_PRODUCT_BOX_LIST_SKELETON_COUNT
}) => {
  const rootClassName = (0, _clsx.default)(_productListClasses.default.root, className);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (renderListSkeleton) {
    return renderListSkeleton();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles3.Root, {
    className: rootClassName,
    "data-testid": getTestId(_constants.PRODUCT_LIST_SKELETON),
    children: [shouldRenderItemCount ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ItemsCounterSkeleton, {
      animation: animation
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      className: _productListClasses.default.list,
      children: (0, _times.default)(numberOfItems).map((_, index) => renderItemSkeleton ? renderItemSkeleton() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBoxSkeleton
      // eslint-disable-next-line react/no-array-index-key -- No other option for passing data to key
      , {
        animation: animation,
        "data-testid": getTestId(_productBox.PRODUCT_BOX_SKELETON)
      }, index))
    }), shouldRenderPagination ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.PaginationSkeleton, {
        animation: animation
      })
    }) : null]
  });
};
exports.ListSkeleton = ListSkeleton;
